import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getDoc, serverTimestamp, setDoc,doc } from 'firebase/firestore';
import React from 'react';
import {FcGoogle} from 'react-icons/fc';
import { toast } from 'react-toastify';
import {db} from '../firebase';
import { useNavigate } from 'react-router';

const OAuth = () => {
  const navigate = useNavigate();
  const onGoogleClick = async () => {

      try {

        const auth = getAuth();
        const provider = new GoogleAuthProvider();

        const result = await signInWithPopup(auth,provider);
        const user = result.user;
        

        //check user in db

        const docRef = doc(db,"users",user.uid);
        const docSnapshot = await getDoc(docRef);

        if(!docSnapshot.exists()){
          await setDoc(docRef,{
            name:user.displayName,
            email:user.email,
            timestamp: serverTimestamp()

          })
        }

        navigate("/");
        
      } catch (error) {
        toast.error("Could not authorize with Google.")
      }


  }

  return (
    
    <button onClick={onGoogleClick} type="button" className="flex items-center rounded justify-center w-full bg-red-700 text-white px-7 py-3 uppercase text-sm font-medium hover:bg-red-800 active:bg-red-900 shadow-md hover:shadow-lg active:shadow-lg transition duration-150 ease-in-out">
    <FcGoogle className="text-2xl  bg-white rounded-full mr-2" />
    Continue With Google
    </button>
  )
}

export default OAuth